import * as yup from 'yup';

export const currentUserProfileValidationSchema = yup.object().shape({
  firstname: yup
    .string()
    .max(30, 'First name is too long!')
    .required('First name is required!'),
  email: yup
    .string()
    .email('Invalid email!')
    .required('Email address is required!')
});
